import React from 'react'
import styled from 'styled-components'



const ConnectDiv = styled.div`
  background-color:#262626;
  display: flex;
  justify-content: center;
  height: 20px;
  position: static;
  top:0;
  right:0;
  z-index:1;
  padding: 10px 10px;
`
const ConnectCaption= styled.h3`
  text-align: center;
  color: white;
  font-size: 12px;
  font-weight:normal;

`

const Disconnect = () => {
  return (
    <>
    <ConnectDiv>
      <ConnectCaption>Wallet Disconnected</ConnectCaption>
    </ConnectDiv>
    </>
  )
}

export default Disconnect